<template>
  <div class="flex flex-col">
    <div class="grow flex flex-col px-4 py-8">
      <FormKit
          type="form"
          submit-label="Continue"
          ref="myForm"
          :actions="false"
          @submit="submitHandler"
      >
        <div class="content !justify-start !h-fit">
          <FormKit
              type="autocomplete"
              name="selectaddress"
              label="Enter your address"
              placeholder="1600 Pennsylvania Avenue NW"
              :options="formattedData"
              validation="required"
              v-model="selectedWorkOrder"
              selection-removable
          />
        </div>
      </FormKit>
      <Errormgs v-if="FMStore?.error" :mgs="FMStore?.errorMessage" />
    </div>
    <Buttons>
      <Button class="btn btn__primary" :disabled="!selectedWorkOrder" :loading="isLoading"
              @click="submitHandler">
        Continue
      </Button>
    </Buttons>
  </div>
</template>

<script setup>
import {ref} from "vue";
import {FormKit} from "@formkit/vue";
import {useFMStore} from "@/store/FMStore";
import Button from "~/components/ui/Button.vue";
import Buttons from "~/components/ui/Buttons.vue";
import Errormgs from "~/components/ui/Errormgs.vue";
const isLoading = ref(false);
const selectedWorkOrder = ref(null);

const FMStore = useFMStore();
const formattedData = FMStore.workOrders.map((item) => ({
  label: item.PremiseAddress,
  value: item,
}));

async function submitHandler() {
  FMStore.selectedWorkOrder = selectedWorkOrder.value;
  FMStore.stepNumber++;
  FMStore.goToStep('Selectdate');
}
</script>
<style>
.address {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}
</style>
